(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/csp-reporting/assets/javascripts/csp-reporting.js') >= 0) return;  svs.modules.push('/components/components/csp-reporting/assets/javascripts/csp-reporting.js');

'use strict';

window.addEventListener('securitypolicyviolation', e => {
  const logger = svs.core.log.getLogger('components:csp-reporting');

  logger.warn("CSP violation: ".concat(e.effectiveDirective, " blocked ").concat(e.blockedURI, " on ").concat(e.documentURI));
});

 })(window);